import { addAddress } from 'shared/models/api';

const EDIT_ADDRESS = 'EDIT_ADDRESS';
const UPDATE_ADDRESS = 'UPDATE_ADDRESS';

const init = {
  addresses: [],
  editingAddress: null
}

export default function reducer(state = init, action = {}) {
  switch (action.type) {
    case EDIT_ADDRESS:
      return {...state, editingAddress: action.address}
    case UPDATE_ADDRESS:
      const addresses = state.addresses.map((address) => {
        return address.clientId === action.address.clientId ? action.address : address;
      });
      return {...state, addresses}
    default:
      return state;
  }
}

export function editAddress(address) {
  return dispatch => dispatch({ type: EDIT_ADDRESS, address })
}

export function updateAddress(address) {
  return dispatch => {
    return addAddress(address).then(() => {
      dispatch({ type: UPDATE_ADDRESS, address });
    });
  }
}



// WEBPACK FOOTER //
// ./shared/components/userAddresses/actions.js